import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getErrorMessage } from 'utils/utilities';
import { selectReauthSessionId } from 'features/reauthenticate/state';
import { useSendPhoneLinkMutation, useSendReauthPhoneLinkMutation } from 'features/common/api';
import validationSchema from './Message.validation';

const initialValues = {
    phoneNumber: '',
    countryCode: '1',
};

export default function useMessageForm({ isReauthenticate, onSent }) {
    const reAuthenticateSessionId = useSelector(selectReauthSessionId);
    const [sendPhoneLink] = useSendPhoneLinkMutation();
    const [sendReauthPhoneLink] = useSendReauthPhoneLinkMutation();

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                if (isReauthenticate) {
                    await sendReauthPhoneLink({
                        sessionId: reAuthenticateSessionId,
                        phoneNumber: values.phoneNumber,
                    }).unwrap();
                } else {
                    await sendPhoneLink({ phoneNumber: values.phoneNumber }).unwrap();
                }
            } catch (error) {
                toast.error(getErrorMessage({ response: { data: error?.data } }));
                return;
            } finally {
                setSubmitting(false);
            }

            // Outside the try for the same reason as the email form: the link has been sent by here,
            // so nothing this throws should be reported back as a failure to send it.
            onSent();
        },
    });

    return { formik };
}
